import React from 'react';
import { useLocation, useNavigate } from 'react-router';

import { FullWidthButton } from '/src/components/form';
import { SimpleLayout } from '/src/layout';

const Page = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <FullWidthButton type="primary" onClick={() => navigate(`/login${location.search}`)}>
      返回登录
    </FullWidthButton>
  );
};

Page.Layout = SimpleLayout;
Page.layoutProps = {
  title: '密码重置成功',
  subtitle: '',
};
Page.headTitle = '重置密码 | PingCAP Account';

export default Page;
